import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { customerQueries } from '@as-react/common-queries';
import { sortAlphabetically } from '@as-react/common-utils';
import { useQuery } from '@tanstack/react-query';
import { SelectAlpha } from '@yonderland/andes-react';
import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { getCountryByFictiveWebShop } from '../../../util/CountryUtil';
import { FormField } from '../FormField';
export const CountrySelector = ({ fieldNamePrefix, onCountryChange }) => {
    const countryFieldName = `${fieldNamePrefix}idCountry`;
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const { defaultRequestParams, servicesEndpoint, lang, fictiveWebShop } = useAemConfig();
    const defaultCountryCode = getCountryByFictiveWebShop(fictiveWebShop);
    const { setValue } = useFormContext();
    const countryValue = useWatch({ name: countryFieldName });
    const { getCountries } = customerQueries({ servicesEndpoint, defaultRequestParams });
    const { data: { countries = [], countiesOptions = [] } = {} } = useQuery(getCountries({
        select: data => ({
            countries: data,
            countiesOptions: sortAlphabetically(data.map(country => ({
                id: country.idCountry,
                text: country.countryDescriptionTranslations[lang.toUpperCase()],
            })), 'text'),
        }),
    }));
    useEffect(() => {
        if (!defaultCountryCode || !!countryValue || !countries.length)
            return;
        const countryByCode = countries.find(country => country.countryCode === defaultCountryCode.toUpperCase());
        setValue(countryFieldName, countryByCode === null || countryByCode === void 0 ? void 0 : countryByCode.idCountry);
    }, [countries, defaultCountryCode]);
    useEffect(() => {
        if (!countryValue || !countries.length)
            return;
        const countryById = countries.find(country => country.idCountry === parseInt(countryValue, 10));
        countryById && onCountryChange(countryById);
    }, [countryValue, countries]);
    return (_jsx(FormField, { name: countryFieldName, children: (_a) => {
            var _b = _a.fieldProps, { ref, value, onChange } = _b, options = __rest(_b, ["ref", "value", "onChange"]), { error } = _a;
            return (_jsx(SelectAlpha, { input: Object.assign(Object.assign({}, options), { id: options.name, label: t('account.details.country'), placeholder: t('account.details.country.placeholder'), innerRef: ref, error }), items: countiesOptions, onSelect: value => onChange(value.id), value: countiesOptions.length ? value : undefined, testId: "country" }));
        } }));
};
